// extracted by mini-css-extract-plugin
export default {"wrap":"KI-z","subtitle":"LI-z","contentWrap":"MI-z","imgWrap":"NI-z","heading":"OI-z","copy":"PI-z"};